import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IntlService } from '@progress/kendo-angular-intl';
import { PageBaseComponent } from './page-base.component';
import { AuthService, DatasourceService } from '@app/core/services';
import { NotificationService } from "@progress/kendo-angular-notification";
import { DialogService, DialogRef, DialogCloseResult } from "@progress/kendo-angular-dialog";
import { Location } from '@angular/common';


@Component({
  selector: 'customer-actions',  
  styleUrls: ['./styles/styles-wrapper.css', './styles/styles-form.css'],
  styles: [`
    form {
      padding: 0 15px 132px 15px;
    }
  `],  
  template: `

    <div class="wrapper-route-0">

      <div class="k-block" *ngIf="loading">
        <kendo-loader [type]="'pulsing'" [size]="'medium'"></kendo-loader>
      </div>

      <form novalidate [formGroup]="form">
        <div class="example-wrapper form-detail">        
          <div class="row">
            <div class="col-field">
              <kendo-label text="R.F.C.:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textbox formControlName="rfc"></kendo-textbox>
              </kendo-textbox-container> 
              <div *ngIf="f.rfc.invalid && (f.rfc.dirty || f.rfc.touched)">                  
                <div *ngIf="f.rfc.errors">
                  <kendo-formerror *ngIf="f.rfc.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Nombre:"></kendo-label>
              <kendo-textbox-container>
                <kendo-textbox formControlName="name"></kendo-textbox>
              </kendo-textbox-container> 
              <div *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)">                  
                <div *ngIf="f.name.errors">
                  <kendo-formerror *ngIf="f.name.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>
            <div class="col-field">
              <kendo-label text="Días de crédito:"></kendo-label>
              <kendo-textbox-container>
                <kendo-numerictextbox formControlName="credit_days" [format]="'n0'" [min]="0" [autoCorrect]="true"></kendo-numerictextbox>
              </kendo-textbox-container> 
              <div *ngIf="f.credit_days.invalid && (f.credit_days.dirty || f.credit_days.touched)">                  
                <div *ngIf="f.credit_days.errors">
                  <kendo-formerror *ngIf="f.credit_days.errors.required">
                    Error: Campo requerido.
                  </kendo-formerror>
                </div>   
              </div>
            </div>                
          </div>
        </div>
      </form>

      <kendo-floatingactionbutton icon="arrow-left" themeColor="secondary" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'start', vertical: 'bottom' }" positionMode="fixed" (click)="goBack()"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="save" themeColor="info" [offset]="{ x: '12px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="onSave($event)" [disabled]='!form.valid && !loading' *ngIf="authService.hasPermission(['CLIENTES:EDITAR'])"></kendo-floatingactionbutton>

      <kendo-floatingactionbutton icon="trash" themeColor="error" [offset]="{ x: '78px', y: '68px' }" [align]="{ horizontal: 'end', vertical: 'bottom' }" positionMode="fixed" (click)="delete()" *ngIf="mode == 'EDIT' && authService.hasPermission(['CLIENTES:ELIMINAR'])">
        
      </kendo-floatingactionbutton>

    </div>

    <div kendoDialogContainer></div>

  `    
})
export class CustomerActionsComponent extends PageBaseComponent implements OnInit {
  
  public id: number = 0;

  public mode = 'CREATE';

  public table: string = 'customers';

  public form!: FormGroup;

  public loading = false;

  public dataItem: any = {};

  public returnUrl: string = 'customers';

  private sub: any;


  constructor(public authService: AuthService, protected router: Router, protected route: ActivatedRoute, protected service : DatasourceService, protected intl: IntlService, private notificationService: NotificationService, private dialogService: DialogService, private location: Location) { 

    super(authService, router)

    let state = location.getState() as {returnUrl: string};
    if(state.returnUrl != null)
      this.returnUrl = state.returnUrl;
    // console.log(this.returnUrl);
    
  }

  //@Override
  protected getFormGroup(dataItem?: any): FormGroup {

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),  
      'rfc': new FormControl((dataItem) ? dataItem.rfc: ''),
      'name': new FormControl((dataItem) ? dataItem.name: '', Validators.required),
      'credit_days': new FormControl((dataItem) ? dataItem.credit_days: 30, Validators.required),
    });

  };

  ngOnInit() {

    // this.form = this.getFormGroup();
    // this.update();

    this.sub = this.route.data.subscribe(v => {
      // console.log(v);
      this.mode = v.mode;
      this.form = this.getFormGroup();
      if(this.mode == 'CREATE') {

      }
      else {
        let id = this.route.snapshot.paramMap.get('id');
        this.id = (id != null) ? parseInt(id): 0;

        // console.log(this.router.getCurrentNavigation());
        this.loading = true;

        this.service.getById(this.table, this.id)
          .subscribe(
            (result: any) => {
              // console.log(result);
              this.dataItem = result;

              this.loading = false;

              this.form = this.getFormGroup(result);
            },
            (error: any) => {
              console.log(error)
              // this.loading = false;
            });

      }

    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  protected getData(formGroup: FormGroup): Object {

    return Object.assign({}, formGroup.value, { 
      // date: this.intl.formatDate(formGroup.value.date, "yyyy-MM-dd"),
    });

  };

  public onDelete(): void {

    this.loading = true;

    this.service.removeRow(this.table, this.dataItem)
      .subscribe(
        (res: any) => {

          this.loading = false;

          const dialog: DialogRef = this.dialogService.open({
            title: "Éxito",
            content: `Se eliminó con éxito ${this.getMessage()}`,
            actions: [{ text: "Ok", primary: true }],
            width: '80%',
            // height: 200,
            // minWidth: 250,
          });
        
          dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {
                // console.log("close");
            }
            this.goBack()
          });

        },
        (error: any) => {
          console.log(error)
          // this.loading = false;
        });

  }

  public onSave(event: any): void {
  
    if(this.form.valid) {

      let data = this.getData(this.form);
      // console.log('data', data)

      this.loading = true;

      if(this.mode == 'CREATE'){
          // console.log(data);
        this.service.addRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("POST Request is successful: ", this.table, data, res);

              this.dataItem = res.data[0];

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se registró con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }
      else {
        this.service.updateRow(this.table, data) 
          .subscribe(
            (res: any) => {
              console.log("PUT Request is successful: ", this.table, data);
              // console.log("mode = " + this.mode);

              this.dataItem = data;
              // this.save.emit({mode: this.mode, dataItem: res.data[0]});

              // this.notificationService.show({
              //     content: `Se registró con éxito el costo de grúa de ${this.intl.formatNumber(res.data[0].cost_crane, "c2")}`,
              //     hideAfter: 1000,
              //     position: { horizontal: "center", vertical: "top" },
              //     animation: { type: "fade", duration: 400 },
              //     type: { style: "success", icon: true },
              //   });

              // this.update();

              this.loading = false;

              const dialog: DialogRef = this.dialogService.open({
                title: "Éxito",
                content: `Se editó con éxito ${this.getMessage()}`,
                actions: [{ text: "Ok", primary: true }],
                width: '80%',
                // height: 200,
                // minWidth: 250,
              });
            
              dialog.result.subscribe((result) => {
                if (result instanceof DialogCloseResult) {
                    // console.log("close");
                }
                this.goBack()
              });

            },
            (fail: any) => {        
              console.log("Error", fail);
              // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
            }
          ); 
      }

    }
    
  }

  public delete() {

    // let that = this;
  
    const dialog: DialogRef = this.dialogService.open({
      title: "Confirmar",
      content: `¿Esta seguro que desea eliminar ${this.getMessage()}?`,
      actions: [{ text: "No", primary: true }, { text: "Sí" }],
      width: '80%',
      // height: 200,
      // minWidth: 250,
    });
  
    dialog.result.subscribe((result) => {
      if (result instanceof DialogCloseResult) {
          // console.log("close");
      }
      else {
        // console.log(result);
        if(result.text == 'Sí') {
          // this.save();
          this.onDelete();
        }
      }
    });

  }

  public goBack() {

    this.router.navigate([`/${this.returnUrl}`]);

  }

  public getMessage() {

    return `el cliente ${this.dataItem.rfc}: ${this.dataItem.name}. ID: [${this.dataItem.id}]?`;

  }
      
}